import {z} from 'zod';

import i18n from '@dms/i18n';

export const BulkAssignMechanicFormSchema = z.object({
  mechanicId: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
});

export type BulkAssignMechanicForm = z.infer<typeof BulkAssignMechanicFormSchema>;
